import LoadingComponent from './Loading.vue'

let instance

export default {
  install(Vue, options) {
    if (!instance) {
      // 实例化组件
      const MyPlugin = Vue.extend(LoadingComponent);
      instance = new MyPlugin({
        el: document.createElement('div')
      });
      document.body.appendChild(instance.$el);
    }
    // 默认属性
    instance.show = false;
    instance.txt = '玩命加载中..'
    // 自定义方法
    let loading = {
      show(txt) {
        instance.show = true;
        if(txt) {
          instance.txt = txt
        } return
      },
      hide() {
        instance.show = false;
      }
    }

    if (!Vue.$hyloading) {
      Vue.$hyloading = loading;
    }

    Vue.mixin({
      created() {
        this.$hyloading = Vue.$hyloading;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/my_plugin/loading/index.js